/**
 * Qualifier for MarginRequirementInquiry to identify a specific report.
 * tag: 1637
 * @readonly
 * @enum {number} (int)
 */
export enum MarginReqmtInqQualifier {
  /** Summary */
  Summary = 0,
  /** Detail */
  Detail = 1,
  /** Excess/Deficit */
  ExcessDeficit = 2,
  /** Net Position */
  NetPosition = 3,
}
